export function dataURLtoFile(dataURI: string, fileName: string) {
  const arr = dataURI.split(',');
  if (!arr || !arr[0]) return;

  const matchMime = arr[0].match(/:(.*?);/);
  if (!matchMime) return;

  const mime = matchMime[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}
